export default {
  tractHudSections: undefined,
  loading: false
}
